<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
export default {
  watch: {
      '$route':{
        handler: (to) => {
          document.title = to.meta.title || 'Your Website'
        },
         immediate: true
      }
    } 
}
</script>

<style lang="scss">
@import "@/stylesheets/_global.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

// Transitions
.slide-fade-enter {
      transform: translateX(100%);
      // opacity: 0; 
    }

  .slide-fade-enter-active,
    .slide-fade-leave-active {
      transition: all 0.2s ease-in-out;
    }
    
    .slide-fade-leave-to {
      transform: translateX(-100%);
      // opacity: 0;
    }
</style>
